
import { useState, useEffect } from 'react';


export const useEnglishMainContentLogic = () => {
  const [englishData, setData] = useState<any>(null);
  const [englishError , setError] = useState<string | null>(null);
  const [open, setOpen] = useState<boolean>(false);
  const [englishDarkMode , setDarkMode] = useState<boolean>(false);
  const [currentChapter, setCurrentChapter] = useState<number>(0);



  useEffect(() => {
    console.log('useEffect is running');
  
    fetch('/data-english.json')
      .then((response) => {
        console.log('Fetching JSON data...');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((jsonData) => {
        setData(jsonData);
        console.log('Data fetched:', jsonData);
      })
      .catch((err) => {
        setError('Error fetching JSON data');
        console.error('Fetch error:', err);
      });
  }, []);
  
  const handleDrawerToggle = () => {
    console.log('Drawer toggle called');
    setOpen(!open);
  };

  const englishHandleThemeChange  = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log('Theme change:', event.target.checked ? 'Dark mode' : 'Light mode');
    setDarkMode(event.target.checked);
  };

  const handleChapterNavigation = (index: number) => {
    console.log('Navigating to chapter:', index);
    setCurrentChapter(index);
  };

  return {
    englishData,
    englishError ,
    open,
    englishDarkMode ,
    currentChapter,
    handleDrawerToggle,
    englishHandleThemeChange ,
    handleChapterNavigation,
  };
}; 